import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaviconsService } from './services/favicons.service';

@NgModule({
  declarations: [],
  providers: [FaviconsService],
  imports: [CommonModule]
})
export class ZonarUiFaviconModule {}
